import {
    CompanyTypes
} from '../ActionTypes/CompanyTypes';

class CompanyActions {

    static getComapny = payload => {
        return {
            type: CompanyTypes.GET_COMPANY,
            payload: payload,
        };
    };

    static updateComapny = payload => {
        return {
            type: CompanyTypes.UPDATE_COMPANY,
            payload: payload,
        };
    };

    static editComapny = payload => {
        return {
            type: CompanyTypes.EDIT_COMPANY,
            payload: payload,
        };
    };

    static clearComapny = () => {
        return {
            type: CompanyTypes.CLEAR_COMPANY,
        };
    };

}

export default CompanyActions;
